export const translations = {
  en: {
    // Navbar
    nav: {
      home: "Home",
      about: "About",
      tours: "Our Tours",
      gallery: "Gallery",
      testimonials: "Testimonials",
      contact: "Contact",
      bookNow: "Book Now"
    },
    // Hero
    hero: {
      slides: [
        {
          title: "Discover the beauty of Senegal",
          subtitle: "Experience authentic and unforgettable experiences"
        },
        {
          title: "Explore Goree Island",
          subtitle: "UNESCO World Heritage site"
        },
        {
          title: "Visit the Pink Lake",
          subtitle: "A natural wonder of Senegal"
        }
      ],
      exploreTours: "Explore our tours",
      contactUs: "Contact us"
    },
    // About
    about: {
      tag: "WHO WE ARE",
      title: "A reliable local African agency",
      text1: "Smiling Senegal is your preferred partner to discover the wonders of Senegal. A local agency specialized in authentic experiences, we offer you tourist circuits, excursions and a true cultural immersion.",
      text2: "Our mission is to make you experience Senegal through its traditions, its vibrant culture and its breathtaking landscapes, while offering you personalized and warm support.",
      button: "Discover our tours",
      badge: {
        years: "10+",
        text: "Years of experience"
      }
    },
    // Why Choose Us
    whyChoose: {
      tag: "WHY CHOOSE US",
      title: "We offer the best\nsafari experiences",
      features: [
        {
          title: "Expert Local Guides",
          text: "Passionate professionals who know every corner of Senegal"
        },
        {
          title: "Personalized Experiences",
          text: "Private tours and custom circuits adapted to your desires"
        },
        {
          title: "Safety Guaranteed",
          text: "Your safety and comfort are our absolute priority"
        },
        {
          title: "Local Authenticity",
          text: "Discover the real Senegal, far from tourist paths"
        }
      ]
    },
    // Tours
    tours: {
      tag: "OUR POPULAR TOURS",
      title: "Explore Senegal with us",
      thingsToDo: "Things To Do",
      list: [
        {
          title: "Goree Island",
          description: "Discover the poignant history of Goree Island, a UNESCO World Heritage site.",
          duration: "Full day",
          groupSize: "2-15 people",
          location: "Dakar, Senegal",
          coordinates: "14.6674,-17.3985"
        },
        {
          title: "Pink Lake (Lake Retba)",
          description: "Admire the spectacular pink waters of this unique lake, famous stage of the Paris-Dakar rally.",
          duration: "Full day",
          groupSize: "2-20 people",
          location: "Niaga, 35 km northeast of Dakar",
          coordinates: "14.8417274,-17.2484392"
        },
        {
          title: "Sine Saloum Delta",
          description: "Explore the mangroves, islands and exceptional wildlife of this nature reserve.",
          duration: "2-3 days",
          groupSize: "2-12 people",
          location: "Fatick and Kaolack regions",
          coordinates: "13.9747149,-16.6512924"
        },
        {
          title: "Bandia Reserve",
          description: "Unforgettable safari to observe giraffes, rhinos, antelopes and many other animals.",
          duration: "Half day",
          groupSize: "2-8 people",
          location: "Bandia, 65 km from Dakar",
          coordinates: "14.5586654,-17.011802"
        },
        {
          title: "Saint-Louis of Senegal",
          description: "Visit the former colonial capital with its unique architecture and jazz festival.",
          duration: "1-2 days",
          groupSize: "2-15 people",
          location: "Saint-Louis, northern Senegal",
          coordinates: "16.0199516,-16.4994989"
        },
        {
          title: "Dakar Tour",
          description: "Discover the vibrant capital: African Renaissance Monument, markets, beaches and urban culture.",
          duration: "Half day",
          groupSize: "2-10 people",
          location: "Dakar, Capital of Senegal",
          coordinates: "14.6937,-17.4441"
        },
        {
          title: "Bassari Country",
          description: "Discover the authentic Bassari Country, a UNESCO World Heritage site.",
          duration: "3 Days",
          groupSize: "2-12 People",
          location: "Kédougou region, southeastern Senegal",
          coordinates: "12.5181078,-12.8747223"
        },
        {
          title: "Casamance",
          description: "Explore the lush and vibrant region of Casamance in southern Senegal.",
          duration: "3-4 Days",
          groupSize: "2-15 People",
          location: "Ziguinchor, southern Senegal",
          coordinates: "12.7711252,-16.3275349"
        },
        {
          title: "Lompoul Desert",
          description: "Experience the Sahara on Senegalese land with a unique desert adventure.",
          duration: "1-2 Days",
          groupSize: "2-20 People",
          location: "Lompoul, 145 km south of Saint-Louis",
          coordinates: "15.3917,-16.7083"
        },
        {
          title: "The Gambia",
          description: "Discover The Gambia, the smiling coast of Africa, with its rich wildlife, beautiful beaches and vibrant culture.",
          duration: "2-3 Days",
          groupSize: "2-15 People",
          location: "Banjul, The Gambia",
          coordinates: "13.4549,-16.5790"
        }
      ],
      bookNow: "Book Now"
    },
    // Gallery
    gallery: {
      tag: "GALLERY",
      title: "Discover Senegal in images"
    },
    // Testimonials
    testimonials: {
      tag: "TESTIMONIALS",
      title: "What our travelers say",
      list: [
        {
          name: "Sarah Johnson",
          country: "USA",
          text: "An unforgettable experience! The team was incredibly professional and the landscapes are breathtaking."
        },
        {
          name: "Pierre Martin",
          country: "France",
          text: "Perfect organization, passionate guides. I highly recommend Smiling Senegal!"
        },
        {
          name: "Maria Garcia",
          country: "Spain",
          text: "Authentic discoveries, warm welcome. A trip that changed my vision of Africa."
        }
      ]
    },
    // Contact
    contact: {
      tag: "CONTACT US",
      title: "Start planning your adventure",
      address: "Address",
      addressText: "Dakar, Senegal",
      phone: "Phone",
      email: "Email",
      form: {
        name: "Your Name",
        email: "Your Email",
        phone: "Phone Number",
        numberOfPeople: "Number of People",
        travelDate: "Travel Date",
        selectTour: "Select a Tour",
        message: "Your Message",
        send: "Send Message",
        success: "Thank you for your message! We will contact you soon."
      }
    },
    // Footer
    footer: {
      description: "Your trusted partner for authentic Senegalese experiences. We bring you closer to the heart of West Africa.",
      quickLinks: "Quick Links",
      services: "Services",
      servicesList: [
        "Tours & Excursions",
        "Cultural Discovery",
        "Private Tours",
        "Group Travel",
        "Hotel Booking"
      ],
      contactUs: "Contact Us",
      rights: "All rights reserved.",
      privacy: "Privacy Policy",
      terms: "Terms of Service"
    }
  },
  fr: {
    // Navbar
    nav: {
      home: "Accueil",
      about: "À propos",
      tours: "Nos Tours",
      gallery: "Galerie",
      testimonials: "Témoignages",
      contact: "Contact",
      bookNow: "Réserver"
    },
    // Hero
    hero: {
      slides: [
        {
          title: "Découvrez la beauté du Sénégal",
          subtitle: "Vivez des expériences authentiques et inoubliables"
        },
        {
          title: "Explorez l'île de Gorée",
          subtitle: "Site du patrimoine mondial de l'UNESCO"
        },
        {
          title: "Visitez le Lac Rose",
          subtitle: "Une merveille naturelle du Sénégal"
        }
      ],
      exploreTours: "Découvrir nos tours",
      contactUs: "Nous contacter"
    },
    // About
    about: {
      tag: "QUI SOMMES-NOUS",
      title: "Une agence africaine locale fiable",
      text1: "Smiling Senegal est votre partenaire privilégié pour découvrir les merveilles du Sénégal. Agence locale spécialisée dans les expériences authentiques, nous vous proposons circuits touristiques, excursions et véritable immersion culturelle.",
      text2: "Notre mission est de vous faire vivre le Sénégal à travers ses traditions, sa culture vibrante et ses paysages à couper le souffle, tout en vous offrant un accompagnement personnalisé et chaleureux.",
      button: "Découvrir nos tours",
      badge: {
        years: "10+",
        text: "Années d'expérience"
      }
    },
    // Why Choose Us
    whyChoose: {
      tag: "POURQUOI NOUS CHOISIR",
      title: "Nous offrons les meilleures\nexpériences de safari",
      features: [
        {
          title: "Guides Locaux Experts",
          text: "Des professionnels passionnés qui connaissent chaque recoin du Sénégal"
        },
        {
          title: "Expériences Personnalisées",
          text: "Tours privés et circuits sur mesure adaptés à vos envies"
        },
        {
          title: "Sécurité Garantie",
          text: "Votre sécurité et votre confort sont notre priorité absolue"
        },
        {
          title: "Authenticité Locale",
          text: "Découvrez le vrai Sénégal, loin des sentiers touristiques"
        }
      ]
    },
    // Tours
    tours: {
      tag: "NOS TOURS POPULAIRES",
      title: "Explorez le Sénégal avec nous",
      thingsToDo: "Activités à faire",
      list: [
        {
          title: "Île de Gorée",
          description: "Découvrez l'histoire poignante de l'île de Gorée, site classé au patrimoine mondial de l'UNESCO.",
          duration: "Journée complète",
          groupSize: "2-15 personnes",
          location: "Dakar, Sénégal",
          coordinates: "14.6674,-17.3985"
        },
        {
          title: "Lac Rose (Lac Retba)",
          description: "Admirez les eaux roses spectaculaires de ce lac unique, célèbre étape du rallye Paris-Dakar.",
          duration: "Journée complète",
          groupSize: "2-20 personnes",
          location: "Niaga, 35 km au nord-est de Dakar",
          coordinates: "14.8417274,-17.2484392"
        },
        {
          title: "Delta du Sine Saloum",
          description: "Explorez les mangroves, îles et faune exceptionnelle de cette réserve naturelle.",
          duration: "2-3 jours",
          groupSize: "2-12 personnes",
          location: "Régions de Fatick et Kaolack",
          coordinates: "13.9747149,-16.6512924"
        },
        {
          title: "Réserve de Bandia",
          description: "Safari inoubliable pour observer girafes, rhinocéros, antilopes et bien d'autres animaux.",
          duration: "Demi-journée",
          groupSize: "2-8 personnes",
          location: "Bandia, 65 km de Dakar",
          coordinates: "14.5586654,-17.011802"
        },
        {
          title: "Saint-Louis du Sénégal",
          description: "Visitez l'ancienne capitale coloniale avec son architecture unique et son festival de jazz.",
          duration: "1-2 jours",
          groupSize: "2-15 personnes",
          location: "Saint-Louis, nord du Sénégal",
          coordinates: "16.0199516,-16.4994989"
        },
        {
          title: "Tour de Dakar",
          description: "Découvrez la capitale vibrante : Monument de la Renaissance Africaine, marchés, plages et culture urbaine.",
          duration: "Demi-journée",
          groupSize: "2-10 personnes",
          location: "Dakar, Capitale du Sénégal",
          coordinates: "14.6937,-17.4441"
        },
        {
          title: "Pays Bassari",
          description: "Découvrez l'authentique Pays Bassari, site classé au patrimoine mondial de l'UNESCO.",
          duration: "3 Jours",
          groupSize: "2-12 Personnes",
          location: "Région de Kédougou, sud-est du Sénégal",
          coordinates: "12.5181078,-12.8747223"
        },
        {
          title: "Casamance",
          description: "Explorez la région luxuriante et vibrante de la Casamance au sud du Sénégal.",
          duration: "3-4 Jours",
          groupSize: "2-15 Personnes",
          location: "Ziguinchor, sud du Sénégal",
          coordinates: "12.7711252,-16.3275349"
        },
        {
          title: "Désert de Lompoul",
          description: "Vivez l'expérience du Sahara sur terre sénégalaise avec une aventure désertique unique.",
          duration: "1-2 Jours",
          groupSize: "2-20 Personnes",
          location: "Lompoul, 145 km au sud de Saint-Louis",
          coordinates: "15.3917,-16.7083"
        },
        {
          title: "La Gambie",
          description: "Découvrez la Gambie, la côte souriante de l'Afrique, avec sa faune riche, ses belles plages et sa culture vibrante.",
          duration: "2-3 Jours",
          groupSize: "2-15 Personnes",
          location: "Banjul, Gambie",
          coordinates: "13.4549,-16.5790"
        }
      ],
      bookNow: "Réserver"
    },
    // Gallery
    gallery: {
      tag: "GALERIE",
      title: "Découvrez le Sénégal en images"
    },
    // Testimonials
    testimonials: {
      tag: "TÉMOIGNAGES",
      title: "Ce que disent nos voyageurs",
      list: [
        {
          name: "Sarah Johnson",
          country: "USA",
          text: "Une expérience inoubliable ! L'équipe était incroyablement professionnelle et les paysages sont à couper le souffle."
        },
        {
          name: "Pierre Martin",
          country: "France",
          text: "Organisation parfaite, guides passionnés. Je recommande vivement Smiling Senegal !"
        },
        {
          name: "Maria Garcia",
          country: "Espagne",
          text: "Découvertes authentiques, accueil chaleureux. Un voyage qui a changé ma vision de l'Afrique."
        }
      ]
    },
    // Contact
    contact: {
      tag: "CONTACTEZ-NOUS",
      title: "Commencez à planifier votre aventure",
      address: "Adresse",
      addressText: "Dakar, Sénégal",
      phone: "Téléphone",
      email: "Email",
      form: {
        name: "Votre Nom",
        email: "Votre Email",
        phone: "Numéro de téléphone",
        numberOfPeople: "Nombre de personnes",
        travelDate: "Date du voyage",
        selectTour: "Sélectionner un tour",
        message: "Votre Message",
        send: "Envoyer le message",
        success: "Merci pour votre message ! Nous vous contacterons bientôt."
      }
    },
    // Footer
    footer: {
      description: "Votre partenaire de confiance pour des expériences sénégalaises authentiques. Nous vous rapprochons du cœur de l'Afrique de l'Ouest.",
      quickLinks: "Liens Rapides",
      services: "Services",
      servicesList: [
        "Tours & Excursions",
        "Découverte Culturelle",
        "Tours Privés",
        "Voyages en Groupe",
        "Réservation d'Hôtels"
      ],
      contactUs: "Contactez-nous",
      rights: "Tous droits réservés.",
      privacy: "Politique de Confidentialité",
      terms: "Conditions d'Utilisation"
    }
  }
};
